import { render } from "./CreateEmptyShippingLabel.vue?vue&type=template&id=40895338&scoped=true"
import script from "./CreateEmptyShippingLabel.vue?vue&type=script&lang=js"
export * from "./CreateEmptyShippingLabel.vue?vue&type=script&lang=js"

import "./CreateEmptyShippingLabel.vue?vue&type=style&index=0&id=40895338&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40895338"]])

export default __exports__